export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9833.fdbde734.jpg";